const ModalTypeInfo    = "ModalTypeInfo";
const ModalTypeConfirm = "ModalTypeConfirm";

export { 
  ModalTypeInfo, ModalTypeConfirm
}

